<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/toplogo.jpg" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/product">产品服务</el-menu-item>
          <el-menu-item index="/case">服务案例</el-menu-item>
          <el-menu-item index="/news">新闻资讯</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
          <el-menu-item index="/download">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>关于我们</p>
              <!-- <span>发展历程</span> -->
              <span>企业文化</span>
              <!-- <span>资质荣誉</span> -->
              <span>合作伙伴</span>
            </li>
            
            <li>
              <p>产品服务</p>
              <!-- <span>介绍视频</span> -->
              <span>保函品种</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>关于我们</p>
              <span>邮箱：459821273@qq. com</span>
              <span>电话：0521一57255637 / 13823202567</span>
              <span>地址：昆山市玉山镇中山路138号中茵写字楼1009</span>
            </li>
          </ul>
          <img src="./assets/img/ercode.jpg" alt />
        </div>
        <div class="copyright">
          <span>
            苏州中柳工程服务有限公司  版权所有     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;     
            备案号： 粤ICP备12345678号 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
            苏ICP备2023007423号
          </span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  created(){
    if(window.location.hash.includes('product')){
      this.defaultActive = "/product"
    }else if(window.location.hash.includes('case')){
      this.defaultActive = "/case"
    }else if(window.location.hash.includes('news')){
      this.defaultActive = "/news"
    }else if(window.location.hash.includes('goin')){
      this.defaultActive = "/goin"
    }else if(window.location.hash.includes('download')){
      this.defaultActive = "/download"
    }
  },
  methods: {
    handleSelect(key) {
      // this.isShow = "/" != key;
      if(key != "/"){
        this.isShow =true
      }else{
        this.isShow =false
      }
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;
  height: 80px!important;
  .logo {
    width: 300px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 80px;
    }
  }
}
.el-header  .el-menu--horizontal>.el-menu-item{
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  font-family: 微软雅黑, Microsoft YaHei;
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 246px;
  overflow: hidden;
  background-color: rgb(44, 43, 43);
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    
    img {
      width: 120px;
      height: 120px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: rgb(44, 43, 43);
    text-align: center;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
.footer-content{
  margin-bottom: 40px;
}
</style>
